/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;




//////////////////
// WEBPACK FOOTER
// ./node_modules/form-data/lib/browser.js
// module id = 293
// module chunks = 76